export default __webpack_public_path__ + "static/media/love-symbol.425eb7ce.svg";